import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Pages } from "./abstract/controller/enum/Pages";
import store from "./abstract/redux/store";
import Panel from "./components/features/panel/Panel";
import ToastProvider from "./components/ui/pop-ups/Toast";
import "./global.css";
import GeneratedDataPage from "./pages/tests/GeneratedDataPage";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <ToastProvider>
      <DndProvider backend={HTML5Backend}>
        <BrowserRouter>
          <Routes>
            <Route path={Pages.ROOT} element={<Panel />} />
            <Route path={Pages.TESTS} element={<GeneratedDataPage />} />
          </Routes>
        </BrowserRouter>
      </DndProvider>
    </ToastProvider>
  </Provider>
  // </React.StrictMode>
);

const loaderElement = document.querySelector(".wrapper");
if (loaderElement) {
  loaderElement.remove();
}
